import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_ME_78 } from "@/lib/programData";

export default function MarrakechErg78Page() {
  return <ProgramTemplate program={PROGRAM_ME_78} variant="me" showJourneyChronology />;
}
